import axios from 'axios';

import { restService, RestService } from 'app/api/common';
import { config } from 'app/config/config';
import { AuthToken } from 'app/api/model/AuthToken';

class AuthService {
    private static readonly BASE_PATH: string = '/auth';

    private readonly restService: RestService;

    public constructor() {
        this.restService = restService;
    }

    public readonly fetchAccessToken = async (code: string, codeVerifier: string): Promise<AuthToken> => {
        const response = await axios.post(
            config.auth.tokenUrl,
            new URLSearchParams({
                grant_type: 'authorization_code',
                redirect_uri: config.auth.redirectUri,
                code_verifier: codeVerifier,
                code,
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                auth: {
                    username: config.auth.clientId,
                    password: '',
                },
            },
        );

        return response.data;
    };

    public readonly logout = (): Promise<void> => this.restService.post(`${AuthService.BASE_PATH}/logout`);
}

const authService = new AuthService();

export { authService, AuthService };
